import CustomizableGeneric from './CustomizableGeneric';

class DeliveryMethod extends CustomizableGeneric {
  getTypeName = () => 'DeliveryMethod';

  getFields = () => ['description'];
}

export default DeliveryMethod;
